import React from 'react'
import RenderOnRole from '../../../../components/RenderOnRole'
import { DIAGNOSIS_READ, DIAGNOSIS_WRITE } from '../../../../utils/roles'
import Diagnosis from '../Diagnosis'

const DiagnosisPhysio = () => {
  return (
    <RenderOnRole
      roles={[DIAGNOSIS_READ, DIAGNOSIS_WRITE]}
      element={<Diagnosis intent='diagnosisPhysio' />}
    />
  )
}

export default DiagnosisPhysio
